if (typeof window.fetch === 'undefined' || typeof window.Headers === 'undefined') {
    // use IIFE for private scope
    (() => {
        window.fetch = params => {
            return new Promise((resolve, reject) => {
                import(/* webpackChunkName: "polyfills/fetch" */ './polyfills/fetch.polyfill').then(() => {
                    window.fetch(params).then(resolve, reject);
                }, reject);
            });
        };


        window.getHeadersPolyfill = function () {
            return new Promise((resolve, reject) => {
                import(/* webpackChunkName: "polyfills/fetch" */ './polyfills/fetch.polyfill').then(() => {
                    resolve();
                }, reject);
            });
        }
    })();
}

// source: https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
(() => {
    if (typeof window.CustomEvent === "function") return false

    function CustomEvent(event, params) {
        params = params || {bubbles: false, cancelable: false, detail: undefined}
        var evt = document.createEvent("CustomEvent")
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
        return evt
    }

    CustomEvent.prototype = window.Event.prototype

    window.CustomEvent = CustomEvent
})();

// source: https://developer.mozilla.org/en-US/docs/Web/API/Element/remove
(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('remove')) {
            return;
        }
        Object.defineProperty(item, 'remove', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function remove() {
                this.parentNode.removeChild(this);
            }
        });
    });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);


// https://gist.github.com/nuxodin/73a2c2423cbbf6818c28ad803985d5c7
// reportValidity IE11 polyfill
(function () {
    if (!HTMLFormElement.prototype.requestSubmit) {
        HTMLFormElement.prototype.requestSubmit = function () {
            // disable feature for IE
        };
    }

    if (!HTMLFormElement.prototype.reportValidity) {
        HTMLFormElement.prototype.reportValidity = function () {
            // disable feature for IE
        };
    }

    if (!HTMLInputElement.prototype.reportValidity) {
        HTMLInputElement.prototype.reportValidity = function () {
            // disable feature for IE
        };
    }
})();

// is IE
if (navigator.userAgent.match(/Trident\/7\./)) {
    import(/* webpackChunkName: "polyfills/formData" */ './polyfills/formData.polyfill')
}

if (!(window.CSS && CSS.supports && CSS.supports("selector(:focus-visible)"))) {
    console.log('no support of :focus-visible, adding polyfill')
    import('focus-visible');
}

import './deprecatedMonkeyPatches'
